import { render, staticRenderFns } from "./VendorEmployeeDashboard.vue?vue&type=template&id=27f63d90&scoped=true&"
import script from "./VendorEmployeeDashboard.vue?vue&type=script&lang=js&"
export * from "./VendorEmployeeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VendorEmployeeDashboard.vue?vue&type=style&index=0&id=27f63d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f63d90",
  null
  
)

export default component.exports